import { render, staticRenderFns } from "./chat-sidebar-esqueleto.vue?vue&type=template&id=23266998&scoped=true&"
import script from "./chat-sidebar-esqueleto.vue?vue&type=script&lang=js&"
export * from "./chat-sidebar-esqueleto.vue?vue&type=script&lang=js&"
import style0 from "./chat-sidebar-esqueleto.vue?vue&type=style&index=0&id=23266998&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23266998",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23266998')) {
      api.createRecord('23266998', component.options)
    } else {
      api.reload('23266998', component.options)
    }
    module.hot.accept("./chat-sidebar-esqueleto.vue?vue&type=template&id=23266998&scoped=true&", function () {
      api.rerender('23266998', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/chat-sidebar-esqueleto/chat-sidebar-esqueleto.vue"
export default component.exports